
import { Cell, CellGroup, Picker } from 'vant'
import { errorModal } from '../../../assets/js/xjcommon';

export default {
  name: 'home',
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Picker.name]: Picker
  },
  data () {
    return {
      // 切换之前的设备
      nowDev: $cookies.get('imei'),
      // 用户选择的设备
      selectDev: '',
      showActionSheetDev: false,
      devList: []
    }
  },
  methods: {
    // 获取当前用户所有设备
    initDevListFn () {
      let _this = this;
      this.$toast.loading({
        overlay: true,
        duration: 0,
        message: '加载中...'
      });
      this.$axios.post('/v3/u/user/getAllVehicle')
        .then(function (response) {
          // console.log(response);
          _this.$toast.clear();
          if (response.data.ret === 0) {
            let devList = [];
            let reqData = response.data.data;
            for (let i = 0; i < reqData.length; i++) {
              let subnameText = reqData[i].imei === _this.$store.state.nowImei ? '当前设备' : '';
              // 把当前设备放在第一位
              if (subnameText) {
                // 不同的显示方式
                // devList.unshift({name: reqData[i].imei, subname: subnameText})
                // devList.unshift({name: reqData[i].imei, disabled: true})
                devList.unshift({name: reqData[i].imei, color: '#007aff'})
              } else {
                devList.push({name: reqData[i].imei, subname: subnameText})
              }
            }
            _this.devList = devList;
            _this.showActionSheetDev = true;
          } else {
            _this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '获取设备列表失败（' + response.data.ret + '）'
            })
          }
        })
        .catch(function (error) {
          _this.$toast.clear();
          errorModal(error, 181);
        })
    },
    // 选择设备
    selectDevFn () {
      this.showActionSheetDev = true;
    },
    onSelectDevFn (e) {
      this.selectDev = e.name;
      this.showActionSheetDev = false;
    },
    // 切换设备 检查
    changeDevFn () {
      if (!this.selectDev || this.nowDev === this.selectDev) {
        this.$dialog({
          message: '设备未发生变化'
        });
        return
      }
      this.changeDevSubmitFn();
    },
    // 切换设备 提交
    changeDevSubmitFn () {
      this.$toast.loading({
        overlay: true,
        duration: 0,
        message: '切换中...'
      });
      this.$axios.post('/v3/u/user/setFavoriteVehicle', { imei: this.selectDev })
        .then((response)=>{
          console.log(response);
          this.$toast.clear();
          if (response.data.ret === 0) {
            // 更新IMEI
            // _this.$store.state.nowImei = response.data.data.imei;
            this.$cookies.set('imei', this.selectDev);
            this.$store.commit('increment', {imei:this.selectDev})
            this.$dialog({
              message: '切换成功'
            }).then(() => {
              this.$store.state.isChangeDev = true;
              this.onCancel();
            })
          } else {
            this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '切换设备失败（' + response.data.ret + '）'
            })
          }
        })
        .catch(function (error) {
          this.$toast.clear();
          errorModal(error, 182);
        })
    },
    // 切换设备成功后回退
    onCancel () {
      this.$router.go(-1);
    },
  },
  created () {
    this.initDevListFn();
  }
}
